import React from 'react'
import { Box, Grid } from '@mui/material';
import Spinner from '../Components/Spinner';
import { Header } from '../Components/Header';
import { LoadingProps } from '../Components/LoginWrapper'
import './Loading.css';

const LoadingPage: React.FC<LoadingProps> = ({ onLogin, isLoading, errorMsg }) => (
  <Box className="LoadingPage" display="flex" flexDirection="column">
    <Header />
      <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          flex={1}
      >
        <div className="content">
          <Box paddingLeft={6}>
            <h1>Welcome!</h1>
            <p className="description">
              Download the latest update of Cleansheet Installation package.
              <br />
              Click the "Login" button and follow the instructions.</p>
            {errorMsg && <h4 className="error-msg">{errorMsg}</h4>}
          </Box>
          <Box display="flex" justifyContent="center" paddingTop={10}>
            <button id="login" onClick={onLogin} className={`btn ${isLoading ? 'btn-loading' : ''}`}>
              {isLoading ? <Spinner /> : 'Login'}
            </button>
          </Box>
        </div>
      </Grid>
  </Box>
)

export default LoadingPage
